
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Divider, EmbeddedYouTubePlayer } from '../../app/components';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    {
      /* KEYWORDS: cli command line interface new project start */
    }
    <h1>{`Brightlayer UI CLI`}</h1>
    <EmbeddedYouTubePlayer videoID={`CESJ9BKLWco`} mdxType="EmbeddedYouTubePlayer" />
    <p>{`The Brightlayer UI CLI (Command-Line Interface) is a tool for quickly starting new projects using Brightlayer UI. It will create a skeleton project in your chosen framework and automatically integrate:`}</p>
    <ul>
      <li parentName="ul">{`Material and Brightlayer UI component libraries`}</li>
      <li parentName="ul">{`Brightlayer UI themes`}</li>
      <li parentName="ul">{`Open Sans Typography package`}</li>
      <li parentName="ul">{`Brightlayer UI colors package`}</li>
      <li parentName="ul">{`Brightlayer UI code formatting and linting profiles (optional)`}</li>
    </ul>
    <p>{`When starting a new project, you will have the opportunity to select a template as your starting point, including a blank template, basic routing template, and a full authentication template.`}</p>
    <blockquote>
      <p parentName="blockquote">{`These templates are available for `}<a parentName="p" {...{
          "href": "https://github.com/brightlayer-ui/angular-cli-templates/blob/master/README.md#angular-cli-templates"
        }}>{`Angular`}</a>{`, `}<a parentName="p" {...{
          "href": "https://github.com/brightlayer-ui/react-cli-templates/blob/master/README.md#react-cli-templates"
        }}>{`React`}</a>{`, `}<a parentName="p" {...{
          "href": "https://github.com/brightlayer-ui/react-native-cli-templates/blob/master/README.md#react-native-cli-templates"
        }}>{`React-Native`}</a>{`, and `}<a parentName="p" {...{
          "href": "https://github.com/brightlayer-ui/angular-cli-templates/blob/master/README.md#angular-cli-templates"
        }}>{`Ionic`}</a>{`.`}</p>
    </blockquote>
    <p>{`To start a new project with the CLI:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`npx -p @brightlayer-ui/cli blui new
`}</code></pre>
    <p>{`For more detailed information and usage instructions, check out the `}<a parentName="p" {...{
        "href": "https://www.npmjs.com/package/@brightlayer-ui/cli"
      }}>{`@brightlayer-ui/cli`}</a>{` package on NPM.`}</p>
    <h2>{`Supported Frameworks`}</h2>
    <p>{`The Brightlayer UI CLI works with all Brightlayer UI supported frameworks: Angular, React, Ionic, and React Native. For React and React Native projects, you will have the option to create your project in TypeScript or JavaScript.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;